import { Box, Button } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { SelectProduct } from './SelectProduct'
import { Controller, useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
//import router from react-router-dom
import { useNavigate } from 'react-router-dom'

const schema = z.object({
  //product é um objeto, e a mensagem de erro é Selecione um produto
  product: z.object({
    nome: z.string().nonempty('Selecione um produto'),
    codigo_produto: z.string().nonempty('Selecione um produto'),
    url_seo: z.string().nonempty('Selecione um produto'),
  }),
})

export function EditarProduto() {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const productSelected = watch('product')

  const navigate = useNavigate()

  console.log('productSelected', productSelected)

  function onSubmit(data) {
    console.log('dados', data)

    navigate(`/financeiro/editar-produto/${productSelected?.codigo_produto}`)
  }

  return (
    <div>
      <HeadingPages name="Editar Produto" />
      <Box
        maxW="768px"
        mx="auto"
        mt="2rem"
        as="form"
        onSubmit={handleSubmit(onSubmit)}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Controller
          name="product"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <SelectProduct
              {...field}
              onSelectProduct={(product) => field.onChange(product)}
              labelInput={productSelected?.nome || 'Selecione um produto'}
            />
          )}
        />
        {errors.product && (
          <Box color="red" fontSize="sm" alignSelf="flex-start">
            Selecione um produto
          </Box>
        )}

        <Button type="submit" colorScheme="blue" mt="1rem" alignSelf="flex-end">
          Continuar
        </Button>
      </Box>
    </div>
  )
}
